import { Stack } from '@mui/material';
import MainCard from 'components/MainCard';
import { useEffect, useMemo, useState } from 'react';
import ClientsService from 'services/clients/Clients';

import Breadcrumbs from 'components/breadcrumb';
import useStateAsync from 'hooks/useStateAsync';
import { LoadingOutlined } from '@ant-design/icons';
import OnechipsSearchContainer from 'components/top-section/containers/OnechipsSearchContainer';
import AccountSelectContainer from 'components/top-section/containers/AccountSelectContainer';
import SelectPlan from 'modules/modals/SelectPlan/containers/SelectPlan';
import { useModal } from 'components/shared/modal/ModalContextProvider';
import MeerkatSelectPlan from 'modules/modals/SelectPlan/containers/MeerkatSelectPlan';
import BulkMeerkatSelectPlan from 'modules/modals/SelectPlan/containers/BulkMeerkatSelectPlan';
import { useTranslation } from 'react-i18next';
import UpdateBannerContainer from 'widgets/update-banner/containers/UpdateBannerContainer';

// ==============================|| MAIN LAYOUT ||============================== //

const mainCardStyles = {
  height: '64px',
  position: 'relative',
  minWidth: '268px',
  backgroundColor: '#fff',
};

const mainCardContentStyles = {
  display: 'flex',
  height: '100%',
  padding: '0 20px',
};

const TopSection = ({ children }) => {
  const modal = useModal();

  const { t } = useTranslation();

  useEffect(() => {
    modal.registerNamedModal(
      'PlanSelectionModal',
      SelectPlan,
      {},
      {
        title: t('views.network_apps.select_apps.network_apps'),
        fullWidth: true,
        maxWidth: 'md',
        close: true,
      }
    );
    modal.registerNamedModal(
      'MeerkatPlanSelectionModal',
      MeerkatSelectPlan,
      {},
      {
        title: t('views.onechip_details.meerkat.actions.add_app'),
        fullWidth: true,
        maxWidth: 'md',
        close: true,
      }
    );

    modal.registerNamedModal(
      'BulkMeerkatPlanSelectionModal',
      BulkMeerkatSelectPlan,
      {},
      {
        title: t('views.onechip_details.meerkat.actions.add_app'),
        fullWidth: true,
        maxWidth: 'md',
        close: true,
      }
    );
  }, []);

  const clients = useStateAsync(ClientsService.getClientsList, {
    clientQueryParameterName: 'clientIds',
    immediate: false,
  });

  useEffect(() => {
    clients.execute({ 'sort.title': 'ASC' });
  }, []);

  const showContent = useMemo(() => {
    if (clients.isSuccess || !clients.isInitialRequest) {
      return true;
    }
    return false;
  }, [clients]);

  return (
    <>
      <Stack pb={2} spacing={2}>
        <MainCard contentSX={mainCardContentStyles} sx={mainCardStyles}>
          <Stack direction="row" alignItems="center" style={{ width: '100%' }} justifyContent="space-between">
            <Breadcrumbs />
            <Stack direction="row" justifySelf={'end'} spacing={6} alignItems="center" justifyContent="end">
              <OnechipsSearchContainer />
              <AccountSelectContainer />
            </Stack>
          </Stack>
        </MainCard>
        <UpdateBannerContainer />
      </Stack>
      {showContent ? <>{children}</> : <LoadingOutlined style={{ fontSize: '36px', color: '#08c' }} />}
    </>
  );
};

export default TopSection;
